<template>
  <div class="submittedSurvey">
    <el-card
      :style="{width: dialogWidth}"
      :body-style="{padding: '70px'}"
    >
      <h2>You already answered to this survey.</h2>
      <p>Thank you for you participation</p>
    </el-card>
  </div>
</template>

<script>
import DialogSetting from '@/mixins/dialog';

export default {
  mixins: [DialogSetting],
};
</script>

<style lang="scss">
.submittedSurvey {
  display: flex;
  justify-content: center;

  .el-card {
    display: inline-block;
  }
}
</style>
